import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { SpaceProp } from '../utils'
import { ifDirectDescendant } from 'components/styles/primitives/selectors/ifDirectDescendant'
import { CSSProperties } from 'react'
import { ifNumChildrenAbove } from 'components/styles/primitives/selectors/ifNumChildrenAbove'
import { FlexMods } from 'components/styles'

interface Props extends SpaceProp {
	/**
	 * @description A valid CSS length specifier with units (e.g. 15px or 50%)
	 */
	minContainerWidth?: CSSProperties['width']
	maxInlineChildren?: number
}

const forceFullWidthIfContainerTooSmall = ({ minContainerWidth = '30em' }: Props) => css`
	${ifDirectDescendant(css`
		flex-grow: 1;
		flex-basis: calc((${minContainerWidth} - 100%) * 999);
	`)}
`

const forceFullWidthIfTooManyChildren = ({ maxInlineChildren }: Props) =>
	maxInlineChildren && ifNumChildrenAbove(maxInlineChildren, FlexMods.Child({ basis: '100%' }))

/**
 * Lays out children equally inline until it is forced to wrap, then lays out children vertically
 * https://every-layout.dev/layouts/switcher/
 * @param minChildWidth {string} - Forces vertical layout if children would shrink below this value
 * @param maxInlineChildren {number} - A number representing the maximum number of items permitted for a horizontal layout
 * @param space {number} - Modify the space between children (uses global space)
 */
export const Switcher = styled.div<Props>`
	${FlexMods.Parent({ wrap: true })};
	${FlexMods.StandardGapSize};
	${forceFullWidthIfContainerTooSmall}
	${forceFullWidthIfTooManyChildren}
`
